var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40ZM34.1006 17.1606L34.2491 17.7777L34.2492 17.7788C34.2585 17.8332 34.4187 18.774 34.4187 20.3501C34.4187 24.1221 33.1182 27.7206 30.602 30.3208C28.0434 32.9625 24.4529 34.4186 20.6645 34.4186C16.5014 34.4186 12.4586 32.907 9.60313 30.0157C6.93145 27.3046 5.58147 23.602 5.58147 19.9965C5.58147 16.391 7.0092 12.5012 9.7657 9.81094C12.5575 7.07906 16.3813 5.58139 20.3676 5.58139C25.5343 5.58139 28.8491 8.20232 30.0578 9.24237L25.9442 13.257C25.2092 12.6052 23.2443 11.1769 20.5019 11.1769C18.1059 11.1769 15.6957 12.0644 14.1054 13.6314C12.5081 15.2053 11.4125 17.5975 11.4125 19.9896C11.4125 22.4094 12.4798 24.76 14.1549 26.3547C15.7876 27.9079 18.2543 28.8716 20.5938 28.8716C23.8097 28.8716 27.7465 26.7915 28.5947 22.8393H20.4242V17.1606H34.1006Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GoogleFilled.44621aa6a47bf3082a5a4da701d69786.svg";